import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("auth_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
export const setToken = (t) => localStorage.setItem("auth_token", t);
export const clearToken = () => localStorage.removeItem("auth_token");
export const getToken = () => localStorage.getItem("auth_token");
